import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Button, Container, createStyles, Grid, makeStyles, TextField, Theme } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
//import { useHistory } from "react-router-dom";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import LoadingDialog from '../controls/LoadingDialog';
import AgregarContacto from '../origenDestino/AgregarContacto';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",

        },
        tr: {
            fontWeight: 600
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "10px"
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            paddingTop: "10px",
            width: "180px"
        },
        textField: {
            marginRight: theme.spacing(1),
            width: 180,
            backgroundColor: "#fff"
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        }
    }),
);

interface IProps {
    nuevoRegistro: () => void
}

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    ayuda: IHelp
}



interface DispatchProps {

}

type Props = StateProps & DispatchProps

const ContactosLista = (props: Props) => {
    

    const classes = useStyles();
    const [showLoading, setLoading] = useState(false);
    const apiSource = useCommonApi();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [contactos, setContactos] = useState<any[]>([]);
    const [nombreCliente, setNombreCliente] = useState('');
    const [puesto, setPuesto] = useState('');
    const [departamento, setDepartamento] = useState('');
    const [agregaContacto, setNuevoContacto] = useState(false);




    React.useEffect(() => {

        buscarContactos();

    }, []);

    function buscarContactos() {
        setLoading(true);
        getContactosCliente().then(data => {

            if (data !== null && data.length) {
                let direccionesDistribuidor: any[] = [];
                let contactosDistribuidor: any[] = [];
                data.forEach(s => {
                    let cont = {
                        id: s.clienteContactoID,
                        nombre: s.nombreClienteDistribuidorContacto,
                        puesto: s.puesto,
                        departamento: s.departamento,
                        telefono: s.telefono,
                        correo: s.correo
                    };
                    contactosDistribuidor.push(cont);
                });
                setContactos(contactosDistribuidor);


            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);

        });
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const cerrarNuevoContacto = () => {
        setNuevoContacto(false);
        buscarContactos();
    };
    const nuevoContacto = () => {
        setNuevoContacto(true);

    };


    const getContactosCliente = async () => {


        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-contacto/distribuidor-filter/" + props.cliente.id, { nombre: nombreCliente, puesto: puesto, departamento: departamento });
        return result;


    };


    return (<>




        <Container maxWidth="xl" className={classes.principal} >

            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Box>
                    <Button variant="contained" color="primary" onClick={nuevoContacto}>
                        {/* Nuevo Contacto */
                            traducirButton(5)}
                    </Button>
                </Box>
            </Box>
        </Container>
        <Container maxWidth="xl" className={classes.filters} >

            <Grid container spacing={3} >
                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Nombre */
                            traducirLabel(201)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <TextField id="outlined-basic" variant="outlined" className={classes.textField}
                        value={nombreCliente} size="small"
                        onChange={e => setNombreCliente(e.target.value)} />
                </Grid>

                <Grid item xs={1}>
                    <div className={classes.label}>
                        {/* Puesto */
                            traducirLabel(243)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <TextField id="outlined-basic" variant="outlined" className={classes.textField} value={puesto}
                        size="small"
                        onChange={e => setPuesto(e.target.value)} />
                </Grid>

                <Grid item xs={1}>
                    <div className={classes.label}>
                        {/* Departamento */
                            traducirLabel(78)}
                    </div>
                </Grid>

                <Grid item xs={2}>
                    <TextField id="outlined-basic" variant="outlined" className={classes.textField} value={departamento}
                        size="small"
                        onChange={e => setDepartamento(e.target.value)} />
                </Grid>

                <Grid item xs={2} className={classes.marginButton} >
                    <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscarContactos()}>
                        <Search />
                    </Button>
                </Grid>
            </Grid>

        </Container>


        <Container maxWidth="xl" style={{ padding: "0" }}>
            <Grid container>
                <Grid item xs={12} className={classes.label}>
                    <Help comments={traducirMessage(80)} customStyle={{ top: "0", right: "0px" }} />
                </Grid>
            </Grid>
        </Container>

        <Container maxWidth="xl" className={classes.table}>

            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* NOMBRE */
                                    traducirLabel(201)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* PUESTO */
                                    traducirLabel(243)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* DEPARTAMENTO */
                                    traducirLabel(78)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* TELÉFONO */
                                    traducirLabel(290)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* CORREO */
                                    traducirLabel(54)}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rowsPerPage > 0
                            ? contactos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : contactos
                        ).map((row, i) => (
                            <TableRow key={i}>

                                <TableCell component="th" scope="row">
                                    {row.nombre}

                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.puesto}

                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.departamento}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.telefono}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.correo}
                                </TableCell>
                            </TableRow>
                        ))}



                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={contactos.length}
                rowsPerPage={rowsPerPage}
                page={page}
                labelRowsPerPage=''
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Container>
        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

        {
            agregaContacto &&
            <AgregarContacto abierto={agregaContacto} cerrar={cerrarNuevoContacto} confirmar={cerrarNuevoContacto} cliente={props.cliente} usuario={props.usuario} setContacto={buscarContactos} ayuda={props.ayuda} />
        }

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactosLista);
